<template>
    <div @click="onClickHeader" class="header">
        <img class="logo" src="../assets/owl-teal.svg" />
        <span class="header-text display-2">Puzzle Of the Day</span>
    </div>
</template>

<script>
export default {
    name: "Header",
    data: () => {
        return {};
    },
    methods: {
        onClickHeader: function() {
            this.$router.push({ path: `/leaderboard` });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 2px solid $pod-teal;
    cursor: pointer;

    .header-text {
        font-family: "Chewy" !important;
        font-weight: bold;
        letter-spacing: 2px !important;

        color: $pod-yellow;
        text-shadow: 1px 2px #275e6d;
    }
}

@media only screen and (max-width: 600px) {
    .header .header-text {
        font-size: 1.8rem !important;
    }
    .logo {
        width: 30px !important;
        margin-left: 0 !important;
    }
}

.logo {
    width: 60px;
    margin: 10px;
    margin-left: -25px;
}
</style>
